import { useFormContext } from 'react-hook-form';

import AutoComplete from 'components/field/AutoComplete';
import FormItem from 'components/form/FormItem';

import { AUTOCOMPLETE } from 'services/consts';

const WAREHOUSE_COLUMNS = [{ accessor: 'Name', width: 200 }];

const DefaultWarehouseField = ({ ...props }) => {
	const { watch, setValue } = useFormContext();
	return (
		<FormItem label="defaultWarehouse" roleName="MultiWarehouseModule" {...props}>
			<AutoComplete
				placeholder="defaultWarehousePlaceholder"
				autoCompleteName={AUTOCOMPLETE.WAREHOUSES}
				columns={WAREHOUSE_COLUMNS}
				selectionLabelAccessor={['Name']}
				value={watch('warehouseID')}
				setValue={(value) => {
					setValue('warehouseID', value?.ID ?? null, {
						shouldValidate: true,
						shouldDirty: true
					});
				}}
			/>
		</FormItem>
	);
};

export default DefaultWarehouseField;
